__turbopack_context__.v({
  "fadeInPublic": "home-public-module__eakdHa__fadeInPublic",
  "heroTitle": "home-public-module__eakdHa__heroTitle",
  "heroTitleLink": "home-public-module__eakdHa__heroTitleLink",
  "introAnchor": "home-public-module__eakdHa__introAnchor",
  "scrollDownLink": "home-public-module__eakdHa__scrollDownLink",
  "tileLink": "home-public-module__eakdHa__tileLink",
  "titleEntrancePublic": "home-public-module__eakdHa__titleEntrancePublic",
});
